import React from 'react';
import { Button } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';

interface ShowMonitorButtonProps {
  testId: string;
}

export const ShowMonitorButton: React.FC<ShowMonitorButtonProps> = ({
  testId,
}) => {
  const nav = useNavigation();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    void nav.examsByTest(testId, true);
  };

  return (
    <Button variant="outline-primary" size="sm" onClick={handleClick}>
      <Icon.Display /> Monitor
    </Button>
  );
};
